import AdSense from "@/components/ads/adsense";
import styles from "./ad-slot-list.module.css";

type Props = {
  slot: string;
};

export default function AdSlot({ slot }: Props) {
  return (
    <div className={styles.adListItem}>
      <div className={styles.adOuter}>
        <div className={styles.adInner}>
          <AdSense slot={slot} />
        </div>
      </div>
    </div>
  );
}
